import { createModule, startNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';
import {
	FormControlLabelStateClass,
	FormControlSiteCoreStateClass,
} from '@project/shared/utils/form-control/js/form-control';
import * as Cookies from 'js-cookie';

const optionValues = {
	referredby: 'applicant_source-referral_friends_family',
	typeofform: 'hr application form',
};

const classes = {
	submitForm: 'js-form__button-event--submit',
	selectErrorClass: 'input-validation-error',
	productsDetailsSection: 'js-form-row-products-category',
	categoryOptionsForCompany: 'js-form__input-category-type-main',
	input: 'js-form__input',
	inputCheckBox: 'a-input-checkbox__input',
};

const jobProfileLocations: { [key: string]: Set<string> } = {};
let stepTwoFormLoaded: boolean = true;
let stepThreeFormLoaded: boolean = true;
let stepFourOneFormLoaded: boolean = true;
let stepFourTwoFormLoaded: boolean = true;
let stepFiveFormLoaded: boolean = true;
@createModule('Form')
/**
 * form module implementation.
 *
 * @author Nele Rabus <nele.rabus@namics.com>
 */
export class Form extends TerrificSpec {
	$ctx: JQuery;
	$inputSelect: JQuery;
	$inputSelect1: JQuery;
	$inputSelectCategory: JQuery;
	productValidation = false;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this._initTerrificModules(this.$ctx);
		// On Form Errors after Submit (e.g. email send fails on BE), Form-Builder does re-render
		// the form and all previous bindings are lost.
		// So we track changes on form-wrapper and re-initialize the Terrific controls
		this.initMutationObserver(this.$ctx);
		this.initAjaxListeners();
		const scFormName = this.$ctx.find("input[data-sc-field-name='TypeOfForm']").val();

		const scFillFormFields = this.$ctx.find("input[data-sc-field-name='FillFormUsingCookieData']").val();

		if (scFillFormFields !== undefined && scFillFormFields.toString() === 'Yes') {
			this.fillFormFieldsUsingCookieData(this.$ctx);
			this.$ctx.on(
				'click',
				`.js-form__button-event--submit-make-an-appointment`,
				this.onMakeAnAppointmentFormSubmit.bind(this)
			);
		}

		if (this.$ctx.data('api-endpoint')) {
			this.fetchCdpIdData();
			this.prefillFormData();

			if (
				scFormName !== undefined &&
				scFormName.toString().toLowerCase() === optionValues.typeofform.toLowerCase()
			) {
				this.$ctx.find(`.o-form__grid-col--input-reffered-by`).hide();
				this.$ctx.find('input[data-sc-field-name="yourReferral"]').val('-');
				this.emailValidationChangeEventForWorkdayForm();
				const inputSelect = 'js-form__input-select-reffered-by';
				this.$inputSelect = this.$ctx.find(`.${inputSelect}`);
				this.$inputSelect.on('change', (ev: Event) => this.inputSelecteOptionChanged(ev));
				this.$ctx.on('click', `.js-form__button-event--submit-application`, this.onFormSubmit.bind(this));
				this.workdayJobsFormData();
			}
		}

		this.initFormHadling();
		if (scFormName !== undefined && scFormName.toString().toLowerCase() === 'company contact') {
			this.$ctx.find(`.${classes.productsDetailsSection}`).addClass('o-form-row-products-category--hide');
			this.$inputSelectCategory = this.$ctx.find(`.${classes.categoryOptionsForCompany}`);
			this.$inputSelectCategory.on('change', (ev: Event) => this.categorySelectedOptionChanged(ev));
		}

		this.initUserVali();
		this.submitButtonClickForGA();
		this.sendFromStartDataToGtm();

		const inputSelect1 = 'js-form__input-select';
		this.$inputSelect1 = this.$ctx.find(`.${inputSelect1}`);
		this.$inputSelect1.on('change', (ev: Event) => this.inputSelecteValidation(ev));

		if (scFormName !== undefined && scFormName.toString().toLowerCase() === 'legal form') {
			const legalFormSectionYesOption = $('.js-form__section-for-yes-option');
			const sectionStepTwo = $('.js-section__steptwo');
			const sectionStepThree = $('.js-section__stepthree');
			const sectionStepFour = $('.js-section__stepfour');
			const sectionStepFive = $('.js-section__stepfive');
			legalFormSectionYesOption.hide();
			sectionStepTwo.hide();
			sectionStepThree.hide();
			sectionStepFour.hide();
			sectionStepFive.hide();

			const radioButtons: any = document.querySelectorAll('.o-form__legal-radio input[type="radio"]');
			const radioButtonsStepTwo: any = document.querySelectorAll(
				'.o-form__legal-steptwo-radio input[type="radio"]'
			);
			const radioButtonsStepThree: any = document.querySelectorAll(
				'.o-form__legal-stepthree-radio input[type="radio"]'
			);
			const radioButtonsStepFourOne: any = document.querySelectorAll(
				'.o-form__legal-stepfour-one-radio input[type="radio"]'
			);
			const radioButtonsStepFourTwo: any = document.querySelectorAll(
				'.o-form__legal-stepfour-two-radio input[type="radio"]'
			);
			const buttonNext: any = document.querySelectorAll('.js-form__button-step-one--submit');
			const buttonNextSecond: any = document.querySelectorAll('.js-form__button-step-two--submit');
			const buttonNextThree: any = document.querySelectorAll('.js-form__button-step-three--submit');
			const buttonNextFour: any = document.querySelectorAll('.js-form__button-step-four-submit');

			radioButtons.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonClick(ev));
			});

			radioButtonsStepTwo.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepTwoClick(ev));
			});

			radioButtonsStepThree.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepThreeClick(ev));
			});

			radioButtonsStepFourOne.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepFourOneClick(ev));
			});

			radioButtonsStepFourTwo.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepFourTwoClick(ev));
			});

			buttonNext.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepOneButtonClick(ev));
			});

			buttonNextSecond.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepTwoButtonClick(ev));
			});

			buttonNextThree.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepThreeOneButtonClick(ev));
			});

			buttonNextThree.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepThreeTwoButtonClick(ev));
			});
			buttonNextFour.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepFourButtonClick(ev));
			});
		}

		if (scFormName !== undefined && scFormName.toString().toLowerCase() === 'manage my preferences') {
			const buttonSubmit: any = document.getElementsByClassName('js-form__manage-my-preferences-submit');
			buttonSubmit[0].addEventListener('click', (ev: Event) => this.onManageMyPrefFormSubmit(ev));
			var urlQuery = window.location.search;
			if (urlQuery !== undefined && urlQuery !== '') {
				let languageContainer: any = document.querySelectorAll('.js-m-navigation-wrapper__language-container');
				if (languageContainer) {
					let languageAnchor: any = languageContainer[0].querySelectorAll('a');
					languageAnchor.forEach((anchor: any) => {
						if (urlQuery.indexOf('cdpid') > -1) {
							var cdpid: string = urlQuery.split('cdpid=')[1];
							if (anchor.href && anchor.href.indexOf('?') > -1) {
								anchor.href =
									anchor.href.split('?')[0] + '?cdpid=' + cdpid + '&' + anchor.href.split('?')[1];
							} else {
								anchor.href = anchor.href.split('?')[0] + '?cdpid=' + cdpid;
							}
						}
					});
				}
			}
		}

		resolve();
	}

	onManageMyPrefFormSubmit(ev: Event) {
		const scManageMyPrefForm: any = $(ev.currentTarget).parents('form:first');
		const userCookieStr = Cookies.get('cdcUserData');
		const profileCookieStr = Cookies.get('cdcProfileData');

		if (!userCookieStr || !profileCookieStr) {
			const profileCookieData: any = {
				firstName: scManageMyPrefForm.find(`[data-sc-field-name="FirstName"]`).val(),
				lastName: scManageMyPrefForm.find(`[data-sc-field-name="LastName"]`).val(),
				email: scManageMyPrefForm.find(`[data-sc-field-name="Email"]`).val(),
				country: scManageMyPrefForm.find(`[data-sc-field-name="Country"]`).val(),
			};

			const workCookieData: any = {
				work: {
					cov_company: scManageMyPrefForm.find(`[data-sc-field-name="Company"]`).val(),
				},
			};

			if (profileCookieData.country === 'US') {
				workCookieData['cov_consent_source_implicit'] = true;
			} else {
				workCookieData['cov_consent_source'] = true;
			}

			Cookies.set('cdcUserData', JSON.stringify(profileCookieData) + '|' + JSON.stringify(workCookieData), {
				expires: 365,
			});
			Cookies.set('cdcProfileData', JSON.stringify(profileCookieData), { expires: 365 });
		} else {
			const cookieObjects = userCookieStr.split('|');
			if (cookieObjects.length < 2) return;

			const profileCookieData: any = JSON.parse(cookieObjects[0]);
			const workCookieData: any = JSON.parse(cookieObjects[1]);

			workCookieData.work.cov_company = scManageMyPrefForm.find(`[data-sc-field-name="Company"]`).val();

			profileCookieData.firstName = scManageMyPrefForm.find(`[data-sc-field-name="FirstName"]`).val();
			profileCookieData.lastName = scManageMyPrefForm.find(`[data-sc-field-name="LastName"]`).val();
			profileCookieData.email = scManageMyPrefForm.find(`[data-sc-field-name="Email"]`).val();
			profileCookieData.country = scManageMyPrefForm.find(`[data-sc-field-name="Country"]`).val();

			if (profileCookieData.country === 'US') {
				workCookieData['cov_consent_source_implicit'] = true;
			} else {
				workCookieData['cov_consent_source'] = true;
			}

			Cookies.set('cdcUserData', JSON.stringify(profileCookieData) + '|' + JSON.stringify(workCookieData), {
				expires: 365,
			});
			Cookies.set('cdcProfileData', JSON.stringify(profileCookieData), { expires: 365 });
		}
	}

	fillFormFieldsUsingCookieData($ctx: JQuery<HTMLElement>) {
		const userCookieStr = Cookies.get('cdcUserData');
		const profileCookieStr = Cookies.get('cdcProfileData');
		let fieldMappings: { [key: string]: any | undefined };

		if (!userCookieStr || !profileCookieStr) {
			fieldMappings = {
				cov_cookie_id: localStorage.getItem('gig_cdp_gmid'),
			};
		} else {
			const cookieObjects = userCookieStr.split('|');
			if (cookieObjects.length < 2) return;

			const profileCookieData = JSON.parse(cookieObjects[0]);
			const workCookieData = JSON.parse(cookieObjects[1]);

			//const optIn = workCookieData.cov_consent_source_implicit || workCookieData.cov_consent_source;

			fieldMappings = {
				FirstName: profileCookieData && profileCookieData.firstName,
				LastName: profileCookieData && profileCookieData.lastName,
				PrimaryEmail: profileCookieData && profileCookieData.email,
				PhoneNumber: profileCookieData && profileCookieData.phones && profileCookieData.phones.number,
				Country: profileCookieData && profileCookieData.country,
				Company: workCookieData && workCookieData.work && workCookieData.work.cov_company,
				JobTitle: workCookieData && workCookieData.work && workCookieData.work.cov_job_title,
				cov_industry: workCookieData && workCookieData.work && workCookieData.work.cov_industry,
				cov_meeting_topic: '',
				cov_cookie_id: localStorage.getItem('gig_cdp_gmid'),
				PrivacyStatement: true,
				TermsandConditions: false,
			};
		}

		for (const fieldName in fieldMappings) {
			if (fieldMappings.hasOwnProperty(fieldName)) {
				const value = fieldMappings[fieldName];
				if (value) {
					const $field = $ctx.find(`[data-sc-field-name="${fieldName}"]`);
					if ($field.length > 0 && $field.attr('type') === 'checkbox') {
						$field.prop('checked', value !== undefined ? value : false); // Check the checkbox
						$field.trigger('change');
						if ($field.attr('data-sc-field-name') === 'PrivacyStatement') {
							$field.parent().hide();
						}
					} else {
						if ($field.length) $field.val(value).trigger('change');
					}
				}
			}
		}

		const fieldsToDisable = [
			'[data-sc-field-name="FirstName"]',
			'[data-sc-field-name="LastName"]',
			'[data-sc-field-name="PrimaryEmail"]',
			'[data-sc-field-name="Company"]',
			'[data-sc-field-name="PrivacyStatement"]',
		];

		fieldsToDisable.forEach((selector) => {
			const $field = $ctx.find(selector);
			if ($field.length > 0 && $field.val() !== null && $field.val() !== '') {
				$field.prop('readonly', true); // Disable the field
			}
		});

		const selectElement: any = $ctx.find(`[data-sc-field-name="Country"]`);
		if (selectElement.length > 0 && selectElement.val() !== null && selectElement.val() !== '') {
			let selectedValue: string = selectElement.val();
			$(selectElement)
				.find('option')
				.each(function() {
					if ($(this).val() !== selectedValue) {
						$(this).prop('disabled', true);
					} else {
						$(this).prop('disabled', false);
					}
				});
			setTimeout(() => {
				$(selectElement)
					.next('span.select2-container')
					.addClass('select-preselected');
			}, 500);
		}

		this.SetCampaignIdForSitecoreForms($ctx);
	}

	SetCampaignIdForSitecoreForms($ctx: JQuery<HTMLElement>) {
		var urlParams = new URLSearchParams(window.location.search);
		var utmId = '';
		if (urlParams.has('utm_id')) {
			utmId = urlParams.get('utm_id');
		}
		if (typeof utmId === 'string' && utmId.length !== 0) {
			$ctx.find(`[data-sc-field-name="cov_campaign_id"]`).val(utmId);
		}
	}

	onMakeAnAppointmentFormSubmit(ev: Event) {
		let __$ctx: any = this.$ctx;
		const userCookieStr = Cookies.get('cdcUserData');
		const profileCookieStr = Cookies.get('cdcProfileData');
		let valivalidationPassed: boolean = false;
		if (
			__$ctx.find(`[data-sc-field-name="FirstName"]`).val() !== '' &&
			__$ctx.find(`[data-sc-field-name="LastName"]`).val() !== '' &&
			__$ctx.find(`[data-sc-field-name="PrimaryEmail"]`).val() !== '' &&
			__$ctx.find(`[data-sc-field-name="Country"]`).val() !== '' &&
			__$ctx.find(`[data-sc-field-name="Company"]`).val() !== '' &&
			__$ctx.find(`[data-sc-field-name="cov_industry"]`).val() !== ''
		) {
			valivalidationPassed = true;
		}

		if (valivalidationPassed === true) {
			Track.setKnownCdcLead(true);
			this.setFormAndCompanionUrls(__$ctx);
			if (!userCookieStr || !profileCookieStr) {
				const profileCookieData: any = {
					firstName: __$ctx.find(`[data-sc-field-name="FirstName"]`).val(),
					lastName: __$ctx.find(`[data-sc-field-name="LastName"]`).val(),
					email: __$ctx.find(`[data-sc-field-name="PrimaryEmail"]`).val(),
					country: __$ctx.find(`[data-sc-field-name="Country"]`).val(),
					phones: { number: __$ctx.find(`[data-sc-field-name="PhoneNumber"]`).val() },
				};

				const workCookieData: any = {
					work: {
						cov_industry: __$ctx.find(`[data-sc-field-name="cov_industry"]`).val(),
						cov_company: __$ctx.find(`[data-sc-field-name="Company"]`).val(),
						cov_job_title: __$ctx.find(`[data-sc-field-name="JobTitle"]`).val(),
					},
				};

				const $checkbox = __$ctx.find('[data-sc-field-name="TermsandConditions"]');
				const marketingOptIn = $checkbox.length > 0 ? $checkbox.prop('checked') : false; // Check if checkbox is checked

				if (marketingOptIn && profileCookieData.country === 'US') {
					workCookieData['cov_consent_source_implicit'] = marketingOptIn;
				} else if (marketingOptIn) {
					workCookieData['cov_consent_source'] = marketingOptIn;
				}

				Cookies.set('cdcUserData', JSON.stringify(profileCookieData) + '|' + JSON.stringify(workCookieData), {
					expires: 365,
				});
				Cookies.set('cdcProfileData', JSON.stringify(profileCookieData), { expires: 365 });
			} else {
				const cookieObjects = userCookieStr.split('|');
				if (cookieObjects.length < 2) return;

				const profileCookieData = JSON.parse(cookieObjects[0]);
				const workCookieData: any = JSON.parse(cookieObjects[1]);

				if (workCookieData && workCookieData.work && workCookieData.work.cov_job_title) {
					workCookieData.work.cov_job_title = __$ctx.find(`[data-sc-field-name="JobTitle"]`).val();
				} else {
					if (workCookieData && workCookieData.work) {
						workCookieData.work['cov_job_title'] = __$ctx.find(`[data-sc-field-name="JobTitle"]`).val();
					} else {
						workCookieData['work'] = {
							cov_job_title: __$ctx.find(`[data-sc-field-name="JobTitle"]`).val(),
						};
					}
				}

				if (profileCookieData && profileCookieData.phones && profileCookieData.phones.number) {
					profileCookieData.phones.number = __$ctx.find(`[data-sc-field-name="PhoneNumber"]`).val();
				} else {
					profileCookieData['phones'] = {
						number: __$ctx.find(`[data-sc-field-name="PhoneNumber"]`).val(),
					};
				}

				if (workCookieData && workCookieData.work) {
					workCookieData.work['cov_industry'] = __$ctx.find(`[data-sc-field-name="cov_industry"]`).val();
				} else {
					workCookieData['work'] = {
						cov_industry: __$ctx.find(`[data-sc-field-name="cov_industry"]`).val(),
					};
				}

				if (workCookieData && workCookieData.work) {
					workCookieData.work['cov_company'] = __$ctx.find(`[data-sc-field-name="Company"]`).val();
				} else {
					workCookieData['work'] = {
						cov_company: __$ctx.find(`[data-sc-field-name="Company"]`).val(),
					};
				}

				const $checkbox = __$ctx.find('[data-sc-field-name="TermsandConditions"]');
				const marketingOptIn = $checkbox.length > 0 ? $checkbox.prop('checked') : false; // Check if checkbox is checked

				if (
					marketingOptIn &&
					profileCookieData &&
					profileCookieData.country &&
					profileCookieData.country === 'US' &&
					workCookieData &&
					workCookieData.cov_consent_source_implicit
				) {
					workCookieData.cov_consent_source_implicit = marketingOptIn;
				} else {
					workCookieData.cov_consent_source_implicit = marketingOptIn;
				}

				if (
					marketingOptIn &&
					profileCookieData &&
					profileCookieData.country &&
					profileCookieData.country !== 'US' &&
					workCookieData &&
					workCookieData.cov_consent_source
				) {
					workCookieData.cov_consent_source = marketingOptIn;
				} else {
					workCookieData.cov_consent_source = marketingOptIn;
				}

				Cookies.set('cdcUserData', JSON.stringify(profileCookieData) + '|' + JSON.stringify(workCookieData), {
					expires: 365,
				});
				Cookies.set('cdcProfileData', JSON.stringify(profileCookieData), { expires: 365 });
			}
		}
	}

	setFormAndCompanionUrls(__$ctx: any) {
		try {
			if (window.location.href === window.parent.location.href) {
				__$ctx.find(`[data-sc-field-name="ParentPageUrl"]`).val(encodeURIComponent(window.location.href));
				this.setCompanionUrls(window.location.href, __$ctx, 'cov_companion_internal_url');
				this.setCompanionUrls(window.location.href, __$ctx, 'cov_companion_external_url');
				console.log('The iframe page URL and parent page URL are the same.');
			} else {
				__$ctx
					.find(`[data-sc-field-name="ParentPageUrl"]`)
					.val(encodeURIComponent(window.parent.location.href));
				this.setCompanionUrls(window.parent.location.href, __$ctx, 'cov_companion_internal_url');
				this.setCompanionUrls(window.parent.location.href, __$ctx, 'cov_companion_external_url');
				console.log('The iframe page URL and parent page URL are different.');
			}
		} catch (error) {
			__$ctx.find(`[data-sc-field-name="ParentPageUrl"]`).val(encodeURIComponent(window.location.href));
			this.setCompanionUrls(window.location.href, __$ctx, 'cov_companion_internal_url');
			this.setCompanionUrls(window.location.href, __$ctx, 'cov_companion_external_url');
			console.log('Cross-origin restriction prevents accessing window.parent.location.href.');
		}
	}

	setCompanionUrls(pageUrl: string, __$ctx: any, companionFieldName: string) {
		let companionMetaUrl = __$ctx.find(`[data-sc-field-name=${companionFieldName}]`).val();
		if (companionMetaUrl && companionMetaUrl.length > 0) {
			let matchedResult = this.replaceUrlPart(pageUrl);
			if (matchedResult && matchedResult.length > 0) {
				let companionUrl = companionMetaUrl + matchedResult[0];
				__$ctx.find(`[data-sc-field-name=${companionFieldName}]`).val(encodeURIComponent(companionUrl));
			}
		}
	}

	replaceUrlPart(pageUrl: string) {
		// Check if window.parent.location.href is defined
		var resultPageUrl = pageUrl.replace('/form/', '/result/');

		// Check if resultPageUrl.match returns a valid result
		if (resultPageUrl) {
			return resultPageUrl.match(/\/result\/.*$/g);
		}
		return '';
	}

	bindRadioButtonClick(event: any) {
		const legalFormSectionYesOption = $('.js-form__section-for-yes-option');
		var inputValue = $(event.target).attr('value');
		if (inputValue == 'Ja') {
			legalFormSectionYesOption.show();
			const hiddenSections: any = document.querySelectorAll('.js-form__section-for-yes-option');

			hiddenSections.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						$(field).val('');
					}
				});
			});
		} else {
			legalFormSectionYesOption.hide();
			const hiddenSections: any = document.querySelectorAll('.js-form__section-for-yes-option');

			hiddenSections.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						if ($(field).attr('type') == 'email') {
							$(field).val('demo@demo.com');
						} else if ($(field).attr('type') == 'number') {
							$(field).val('1234567890');
						} else if ($(field).attr('type') == 'tel') {
							$(field).val('0');
						} else {
							$(field).val('-');
						}
					}
				});
			});
		}
	}

	bindRadioButtonStepTwoClick(event: any) {
		const legalFormSectionRegStromOption = $('.js-form__section-registration-strom');
		const legalFormSectionRegGasOption = $('.js-form__section-registration-gas');
		const spanFileUploadValidationMessage = $('.js-form__file-upload-validation-message');
		legalFormSectionRegGasOption.hide();
		legalFormSectionRegStromOption.hide();
		spanFileUploadValidationMessage.hide();

		const selectBoxStepTwo: any = $('.o-form__legal-steptwo-select');
		if (
			selectBoxStepTwo.val() !== 'Veränderung Netzanschluss' &&
			selectBoxStepTwo.val() !== 'Abmeldung Netzanschluss'
		) {
			var inputValue = $(event.target).attr('value');
			if (inputValue == 'Gas') {
				legalFormSectionRegGasOption.show();
				const hiddenSections: any = document.querySelectorAll(
					'.js-form__section-registration-strom,.js-form__section-registration-meter-number'
				);
				hiddenSections.forEach((section: any) => {
					const fields = section.querySelectorAll('input,textarea,select');
					fields.forEach((field: any) => {
						if (field.tagName === 'SELECT') {
							$(field).val('10 kV*');
						} else if ($(field).attr('type') !== 'hidden') {
							$(field).val('-');
						}
					});
				});
			} else if (inputValue == 'Strom') {
				legalFormSectionRegStromOption.show();
				const hiddenSections: any = document.querySelectorAll(
					'.js-form__section-registration-gas,.js-form__section-registration-meter-number'
				);
				hiddenSections.forEach((section: any) => {
					const fields = section.querySelectorAll('input, select, textarea');
					fields.forEach((field: any) => {
						if ($(field).attr('type') !== 'hidden') {
							$(field).val('-');
						}
					});
				});
			} else {
				legalFormSectionRegGasOption.hide();
				legalFormSectionRegStromOption.hide();
			}
		}
		const fileUploadControls = Array.from(
			document.querySelectorAll('.js-form__section-registration-file-upload-control')
		);
		fileUploadControls.forEach((control) => {
			control.addEventListener('change', (ev) => this.bindFileUploadClick(ev));
		});
	}

	bindFileUploadClick(event: any) {
		const fileInput = event.target as HTMLInputElement;
		if (fileInput.files && fileInput.files.length > 0) {
			const file = fileInput.files[0];

			// Use FileReader to read the file as a base64 string
			const reader = new FileReader();
			reader.onloadend = function() {
				const base64String = reader.result as string;

				// Create an object to hold the base64 string and the file name
				const fileData = {
					base64: base64String,
					name: file.name,
				};

				// Convert the object to a JSON string
				const fileDataJson = JSON.stringify(fileData);

				// Find the hidden field where we will store the base64 string and file name
				const hiddenField = document.querySelector(
					'input[data-sc-field-name="hiddenFieldForFile"]'
				) as HTMLInputElement | null;
				if (hiddenField) {
					hiddenField.value = fileDataJson; // Store JSON string in the hidden field
				}

				console.log('File Data JSON:', fileDataJson); // Optionally log the JSON string
			};

			// Read the file as a Data URL (Base64-encoded)
			reader.readAsDataURL(file);
		} else {
			alert('Please select a file to upload.');
		}
	}

	bindRadioButtonStepThreeClick(event: any) {
		const legalFormSectionYesOption = $('.js-form__section-for-yes-option');
		legalFormSectionYesOption.hide();
		var inputValue = $(event.target).attr('value');
		if (inputValue == 'Ja') {
			legalFormSectionYesOption.show();
			const hiddenSections: any = document.querySelectorAll('.js-form__section-for-yes-option');

			hiddenSections.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						$(field).val('');
					}
				});
			});
		} else {
			legalFormSectionYesOption.hide();
			const hiddenSections: any = document.querySelectorAll('.js-form__section-for-yes-option');

			hiddenSections.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						if ($(field).attr('type') == 'email') {
							$(field).val('demo@demo.com');
						} else if ($(field).attr('type') == 'number') {
							$(field).val('1234567890');
						} else if ($(field).attr('type') == 'tel') {
							$(field).val('0');
						} else {
							$(field).val('-');
						}
					}
				});
			});
		}
	}

	bindRadioButtonStepFourOneClick(event: any) {
		const legalFormSectionYesOption = $('.js-form__section-for-yes-option-next');
		const legalFormSectionNextYesOptionYes = $('.js-form__section-for-next-yes-option-yes');
		const legalFormSectionNo = $('.js-form__section-for-no-option');
		legalFormSectionYesOption.hide();
		legalFormSectionNextYesOptionYes.hide();
		legalFormSectionNo.hide();
		var inputValue = $('.o-form__legal-stepfour-one-radio input[type="radio"]:checked').val();
		if (inputValue == 'Ja') {
			const radioButtonsStepFourTwo = document.querySelectorAll(
				'.o-form__legal-stepfour-two-radio input[type="radio"]'
			);
			const radioButtonsStepFourArray = Array.from(radioButtonsStepFourTwo);
			radioButtonsStepFourArray.forEach((radio: any) => {
				$(radio).prop('checked', false);
			});
			legalFormSectionYesOption.show();
		} else {
			legalFormSectionYesOption.hide();
			legalFormSectionNextYesOptionYes.hide();
			legalFormSectionNo.hide();
			const hiddenSections: any = document.querySelectorAll(
				'.js-form__section-for-no-option,.js-form__section-for-next-yes-option-yes,.js-form__section-for-yes-option-next'
			);
			hiddenSections.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea, input[type="radio"]');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						if ($(field).attr('type') == 'email') {
							$(field).val('demo@demo.com');
						} else if ($(field).attr('type') == 'number') {
							$(field).val('1234567890');
						} else if ($(field).attr('type') == 'tel') {
							$(field).val('0');
						} else if ($(field).attr('type') == 'radio') {
							$(field).prop('checked', true);
						} else {
							$(field).val('-');
						}
					}
				});
			});
		}
	}

	bindRadioButtonStepFourTwoClick(event: any) {
		const legalFormSectionNextYesOptionYes = $('.js-form__section-for-next-yes-option-yes');
		const legalFormSectionNo = $('.js-form__section-for-no-option');
		legalFormSectionNo.hide();
		var inputValue = $('.o-form__legal-stepfour-two-radio input[type="radio"]:checked').val();
		if (inputValue == 'Ja') {
			legalFormSectionNextYesOptionYes.show();
			const hiddenSections: any = document.querySelectorAll('.js-form__section-for-next-yes-option-yes');
			hiddenSections.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						$(field).val('');
					}
				});
			});
			const hiddenSectionNo: any = document.querySelectorAll('.js-form__section-for-no-option');
			hiddenSectionNo.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea,input[type="radio"]');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						if ($(field).attr('type') == 'email') {
							$(field).val('demo@demo.com');
						} else if ($(field).attr('type') == 'number') {
							$(field).val('1234567890');
						} else if ($(field).attr('type') == 'tel') {
							$(field).val('0');
						} else if ($(field).attr('type') == 'radio') {
							$(field).prop('checked', true);
						} else {
							$(field).val('-');
						}
					}
				});
			});
		} else if (inputValue == 'Nein') {
			legalFormSectionNextYesOptionYes.hide();
			legalFormSectionNo.show();
			const hiddenSections: any = document.querySelectorAll('.js-form__section-for-no-option');
			hiddenSections.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						$(field).val('');
					}
				});
			});
			const hiddenSectionYes: any = document.querySelectorAll('.js-form__section-for-next-yes-option-yes');
			hiddenSectionYes.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						$(field).val('-');
					}
				});
			});
		} else {
			legalFormSectionNextYesOptionYes.hide();
			legalFormSectionNo.hide();
			const hiddenSections: any = document.querySelectorAll(
				'.js-form__section-for-no-option,.js-form__section-for-next-yes-option-yes'
			);
			hiddenSections.forEach((section: any) => {
				const fields = section.querySelectorAll('input, select, textarea,input[type="radio"]');
				fields.forEach((field: any) => {
					if ($(field).attr('type') !== 'hidden') {
						if ($(field).attr('type') == 'email') {
							$(field).val('demo@demo.com');
						} else if ($(field).attr('type') == 'number') {
							$(field).val('1234567890');
						} else if ($(field).attr('type') == 'tel') {
							$(field).val('0');
						} else if ($(field).attr('type') == 'radio') {
							$(field).prop('checked', true);
						} else {
							$(field).val('-');
						}
					}
				});
			});
		}
	}

	bindRadioButtonStepFiveClick(event: any) {}

	bindSelectBoxStepTwoChange(event: any) {
		if (event.currentTarget.value === 'Veränderung Netzanschluss') {
			this.hideStepTwoDateSection();
			this.hideStepTwoGasSection();
			this.hideStepTwoStromSection();
			this.hideStepTwoFileUploadSection();
			$('.js-form__file-upload-validation-message').hide();
			this.hideStepTwoMeterNoSection();
		} else if (event.currentTarget.value === 'Abmeldung Netzanschluss') {
			$('.js-form__section-registration-date').show();
			$('.js-form__section-registration-meter-number').show();
			this.hideStepTwoGasSection();
			this.hideStepTwoStromSection();
			this.hideStepTwoFileUploadSection();
			$('.js-form__file-upload-validation-message').hide();
		} else {
			$('.js-form__section-registration-date').show();
			$('.js-form__file-upload-validation-message').hide();
			$('.js-form__section-registration-file-upload').show();
			this.hideStepTwoMeterNoSection();
		}
	}

	hideStepTwoDateSection() {
		$('.js-form__section-registration-date').hide();
		const hiddenSectionsDate: any = document.querySelectorAll('.js-form__section-registration-date');

		hiddenSectionsDate.forEach((section: any) => {
			const fields = section.querySelectorAll('input, select, textarea, input[type="date"]');
			fields.forEach((field: any) => {
				if ($(field).attr('type') !== 'hidden') {
					$(field).val('1900-01-01');
				}
			});
		});
	}

	hideStepTwoMeterNoSection() {
		$('.js-form__section-registration-meter-number').hide();
		const hiddenSectionsMeterNo: any = document.querySelectorAll('.js-form__section-registration-meter-number');

		hiddenSectionsMeterNo.forEach((section: any) => {
			const fields = section.querySelectorAll('input, select, textarea');
			fields.forEach((field: any) => {
				if ($(field).attr('type') !== 'hidden') {
					$(field).val('-');
				}
			});
		});
	}

	hideStepTwoGasSection() {
		$('.js-form__section-registration-gas').hide();
		const hiddenSectionsGas: any = document.querySelectorAll('.js-form__section-registration-gas');

		hiddenSectionsGas.forEach((section: any) => {
			const fields = section.querySelectorAll('input, select, textarea');
			fields.forEach((field: any) => {
				if ($(field).attr('type') !== 'hidden') {
					$(field).val('-');
				}
			});
		});
	}

	hideStepTwoStromSection() {
		$('.js-form__section-registration-strom').hide();
		const hiddenSectionsStrom: any = document.querySelectorAll('.js-form__section-registration-strom');

		hiddenSectionsStrom.forEach((section: any) => {
			const fields = section.querySelectorAll('input, select, textarea');
			fields.forEach((field: any) => {
				if (field.tagName === 'SELECT') {
					$(field).val('10 kV*');
				} else if ($(field).attr('type') !== 'hidden') {
					$(field).val('-');
				}
			});
		});
	}

	hideStepTwoFileUploadSection() {
		$('.js-form__section-registration-file-upload').hide();
		const hiddenSectionsFileUpload: any = document.querySelectorAll('.js-form__section-registration-file-upload');

		hiddenSectionsFileUpload.forEach((section: any) => {
			const fields = section.querySelectorAll('input, select, textarea, input[type="file"]');
			fields.forEach((field: any) => {
				if ($(field).attr('type') !== 'hidden') {
					$(field).removeClass('field-validation-error');
				}
			});
		});
	}

	triggerFileUploadValidation(event: any) {
		let stepThreeFormLoaded = false;
		const inputFileUploadControl: any = document.querySelector(
			'.js-form__section-registration-file-upload-control'
		);
		const spanFileUploadValidationMessage: any = document.querySelector('.js-form__file-upload-validation-message');
		if (inputFileUploadControl && inputFileUploadControl.files.length !== 0) {
			spanFileUploadValidationMessage.style.display = 'none';
			stepThreeFormLoaded = true;
		} else {
			spanFileUploadValidationMessage.style.display = 'block';
			event.preventDefault();
			return false;
		}
	}

	bindStepOneButtonClick(event: any) {
		stepTwoFormLoaded = true;
	}

	bindStepTwoButtonClick(event: any) {
		const selectBoxStepTwo: any = $('.o-form__legal-steptwo-select');
		if (
			selectBoxStepTwo.val() !== 'Veränderung Netzanschluss' &&
			selectBoxStepTwo.val() !== 'Abmeldung Netzanschluss'
		) {
			this.triggerFileUploadValidation(event);
		}
	}
	bindStepThreeOneButtonClick(event: any) {
		stepFourOneFormLoaded = true;
	}
	bindStepThreeTwoButtonClick(event: any) {
		stepFourTwoFormLoaded = true;
	}
	bindStepFourButtonClick(event: any) {
		stepFiveFormLoaded = true;
	}
	/// Preview Button From  2 to 1 Start
	bindStepTwoPreviousButtonClick(event: any) {
		setTimeout(() => {
			const radioButtons: any = document.querySelectorAll('.o-form__legal-radio input[type="radio"]');
			const legalFormSectionYesOption = $('.js-form__section-for-yes-option');
			radioButtons.forEach((radio: any) => {
				if (radio.checked) {
					if (radio.value !== 'Ja') {
						legalFormSectionYesOption.hide();
					}
				}
			});

			radioButtons.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonClick(ev));
			});

			const buttonNext: any = document.querySelectorAll('.js-form__button-step-one--submit');
			buttonNext.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepOneButtonClick(ev));
			});
		}, 1000);
	}
	/// Preview Button From  2 to 1 End
	/// Preview Button From  3 to 2 Start
	bindStepThreePreviousButtonClick(event: any) {
		setTimeout(() => {
			const legalFormSectionRegStromOption = $('.js-form__section-registration-strom');
			const legalFormSectionRegGasOption = $('.js-form__section-registration-gas');
			const hiddenSectionsMeterNo = $('.js-form__section-registration-meter-number');
			const spanFileUploadValidationMessage = $('.js-form__file-upload-validation-message');
			const hiddenSectionsDate = $('.js-form__section-registration-date');
			const hiddenSectionsFileUpload = $('.js-form__section-registration-file-upload');
			hiddenSectionsMeterNo.hide();
			legalFormSectionRegGasOption.hide();
			legalFormSectionRegStromOption.hide();
			spanFileUploadValidationMessage.hide();
			hiddenSectionsDate.hide();
			hiddenSectionsFileUpload.hide();

			const radioButtonsStepTwo: any = document.querySelectorAll(
				'.o-form__legal-steptwo-radio input[type="radio"]'
			);
			const selectBoxStepTwo: any = $('.o-form__legal-steptwo-select');
			if (
				selectBoxStepTwo.val() !== 'Veränderung Netzanschluss' &&
				selectBoxStepTwo.val() !== 'Abmeldung Netzanschluss'
			) {
				hiddenSectionsFileUpload.show();
				hiddenSectionsDate.show();
				var inputValue = $('input[type="radio"]:checked').val();
				if (inputValue == 'Gas') {
					legalFormSectionRegGasOption.show();
				} else if (inputValue == 'Strom') {
					legalFormSectionRegStromOption.show();
				} else {
					legalFormSectionRegGasOption.hide();
					legalFormSectionRegStromOption.hide();
				}
			} else if (selectBoxStepTwo.val() === 'Veränderung Netzanschluss') {
				this.hideStepTwoDateSection();
				this.hideStepTwoGasSection();
				this.hideStepTwoStromSection();
				this.hideStepTwoFileUploadSection();
				this.hideStepTwoMeterNoSection();
				spanFileUploadValidationMessage.hide();
				hiddenSectionsFileUpload.hide();
				hiddenSectionsDate.hide();
			} else {
				$('.js-form__section-registration-date').show();
				$('.js-form__section-registration-meter-number').show();
				this.hideStepTwoGasSection();
				this.hideStepTwoStromSection();
				this.hideStepTwoFileUploadSection();
				spanFileUploadValidationMessage.hide();
			}
			radioButtonsStepTwo.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepTwoClick(ev));
			});

			const buttonNextSecond: any = document.querySelectorAll('.js-form__button-step-two--submit');
			buttonNextSecond.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepTwoButtonClick(ev));
			});
		}, 1000);
	}
	/// Preview Button From  3 to 2 End
	/// Preview Button From  4 to 3 Start
	bindStepFourPreviousButtonClick(event: any) {
		setTimeout(() => {
			const radioButtonsStepThree: any = document.querySelectorAll(
				'.o-form__legal-stepthree-radio input[type="radio"]'
			);
			const legalFormSectionYesOption = $('.js-form__section-for-yes-option');
			radioButtonsStepThree.forEach((radio: any) => {
				if (radio.checked) {
					if (radio.value !== 'Ja') {
						legalFormSectionYesOption.hide();
					} else {
						legalFormSectionYesOption.show();
					}
				}
			});

			radioButtonsStepThree.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepThreeClick(ev));
			});

			const buttonNextThree: any = document.querySelectorAll('.js-form__button-step-three--submit');
			buttonNextThree.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepThreeOneButtonClick(ev));
			});
		}, 1000);
	}
	/// Preview Button From  4 to 3 End
	/// Preview Button From  5 to 4 Start
	bindStepFivePreviousButtonClick(event: any) {
		setTimeout(() => {
			const radioButtonsStepFourOne: any = document.querySelectorAll(
				'.o-form__legal-stepfour-one-radio input[type="radio"]'
			);
			const legalFormSectionYesOption = $('.js-form__section-for-yes-option-next');
			const legalFormSectionNextYesOptionYes = $('.js-form__section-for-next-yes-option-yes');
			const legalFormSectionNo = $('.js-form__section-for-no-option');
			legalFormSectionYesOption.hide();
			legalFormSectionNextYesOptionYes.hide();
			legalFormSectionNo.hide();

			var inputValue = $('.o-form__legal-stepfour-one-radio input[type="radio"]:checked').val();
			if (inputValue == 'Ja') {
				legalFormSectionYesOption.show();
				var inputValueTwo = $('.o-form__legal-stepfour-two-radio input[type="radio"]:checked').val();
				if (inputValueTwo == 'Ja') {
					legalFormSectionNextYesOptionYes.show();
				} else {
					legalFormSectionNo.show();
				}
			} else {
				legalFormSectionYesOption.hide();
				legalFormSectionNextYesOptionYes.hide();
				legalFormSectionNo.hide();
				const hiddenSections: any = document.querySelectorAll(
					'.js-form__section-for-no-option,.js-form__section-for-next-yes-option-yes,.js-form__section-for-yes-option-next'
				);
				hiddenSections.forEach((section: any) => {
					const fields = section.querySelectorAll('input, select, textarea, input[type="radio"]');
					fields.forEach((field: any) => {
						if ($(field).attr('type') !== 'hidden') {
							if ($(field).attr('type') == 'email') {
								$(field).val('demo@demo.com');
							} else if ($(field).attr('type') == 'number') {
								$(field).val('1234567890');
							} else if ($(field).attr('type') == 'tel') {
								$(field).val('0');
							} else if ($(field).attr('type') == 'radio') {
								$(field).prop('checked', true);
							} else {
								$(field).val('-');
							}
						}
					});
				});
				radioButtonsStepFourOne.forEach((radio: any) => {
					radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepFourOneClick(ev));
				});

				const buttonNextFour: any = document.querySelectorAll('.js-form__button-step-four-submit');
				buttonNextFour.forEach((button: any) => {
					button.addEventListener('click', (ev: Event) => this.bindStepFourButtonClick(ev));
				});
			}
		}, 1000);
	}
	/// Preview Button From  5 to 4 End
	onFormSubmit(ev: Event) {
		const $fieldValidationError = this.$ctx.find('.field-validation-error');
		const $fieldValidationErrorLength = this.$ctx.find('.field-validation-error').length;
		var $validationErrorCount = 0;

		if ($fieldValidationErrorLength === 0) {
			this.$ctx.find('input[data-sc-field-name="applicationFormSubmitClicked"]').val('true');
		} else {
			$fieldValidationError.each((index, element) => {
				const $validationError = $(element);
				if (!$validationError.is(':visible')) {
					$validationErrorCount = $validationErrorCount + 1;
				}
			});

			if ($fieldValidationErrorLength === $validationErrorCount) {
				this.$ctx.find('input[data-sc-field-name="applicationFormSubmitClicked"]').val('true');
			} else {
				ev.preventDefault();
				return false;
			}
		}
		const contactingCategoryField = this.$ctx.find("[data-sc-field-name='ContactingCategory']");
		if (contactingCategoryField.length !== 0) {
			var productvalue: any = $(contactingCategoryField).val();
			if (productvalue.toLowerCase() === 'products') {
				let MktoForms2 = (window as any)['MktoForms2'];
				if (typeof MktoForms2 != 'undefined') {
					const hiddenMktoForm: any = this.$ctx.find("div[data-allow-hidden-form-submit='true']");
					if (hiddenMktoForm.length > 0) {
						var mktoFormId = $(hiddenMktoForm[0]).attr('data-form-id');
						let myHiddenMktoForm: any = MktoForms2.getForm(mktoFormId);
						let myHiddenFormFields: any = myHiddenMktoForm.vals();
						var myMktoHiddenMetaDataString = this.$ctx.find(`#dynamicDataSourceFieldsJsonString`).text();
						let myMktoHiddenMetaData: any;
						if (myMktoHiddenMetaDataString.length > 0) {
							myMktoHiddenMetaDataString = myMktoHiddenMetaDataString.replace('][', ',');
							myMktoHiddenMetaData = JSON.parse(myMktoHiddenMetaDataString);
						}

						let materialTagValue = this.$ctx.find("[data-sc-field-name='materialTag']").val();
						let industryTagValue = this.$ctx.find("[data-sc-field-name='industryType']").val();

						var firstName = this.$ctx.find("[data-sc-field-name='FirstName']").val();
						var lastName = this.$ctx.find("[data-sc-field-name='LastName']").val();
						var email = this.$ctx.find("[data-sc-field-name='Email']").val();
						var country = this.$ctx.find("[data-sc-field-name='Country']").val();
						var company = this.$ctx.find("[data-sc-field-name='Company']").val();

						if (typeof myHiddenFormFields != 'undefined') {
							myHiddenMktoForm.addHiddenFields({
								//These are the values which will be submitted to Marketo
								formMessage: this.$ctx.find("[data-sc-field-name='FormMessage']").val(),
								FirstName: firstName,
								LastName: lastName,
								Email: email,
								Country: country,
								Company: company,
								mktoindustry: this.getValueFromObject(myMktoHiddenMetaData, industryTagValue),
								inferredMaterialInterest: this.getValueFromObject(
									myMktoHiddenMetaData,
									materialTagValue
								),
								privacyPolicyAcceptance: true,
								mktooptinchkbxacceptance: true,
							});

							if (
								typeof firstName !== 'undefined' &&
								firstName.toString().length > 0 &&
								typeof lastName !== 'undefined' &&
								lastName.toString().length > 0 &&
								typeof email !== 'undefined' &&
								email.toString().length > 0 &&
								typeof country !== 'undefined' &&
								country.toString().length > 0 &&
								typeof company !== 'undefined' &&
								company.toString().length > 0
							) {
								myHiddenMktoForm.submit();
							}
						}
					}
				}
			}
		}
	}

	initFormHadling() {
		this.$ctx.on('click', `.${classes.submitForm}`, this.onFormSubmit.bind(this));
	}

	stop() {
		// needs to be here for terrific
	}

	_initTerrificModules($ctx: JQuery) {
		const cancelButtonSelector = 'js-form__button-event--cancel';
		const terrificControlMap = [
			{
				selector: '.js-form__input, .js-form__input-number, .js-form__input-email, .js-form__input-date',
				terrificName: 'Input',
				componentAttr: [],
			},
			{
				selector: '.js-form__input-textarea',
				terrificName: 'InputTextarea',
				componentAttr: [],
			},
			{
				selector: '.js-form__input-select',
				terrificName: 'InputSelect',
				componentAttr: [
					{
						helperClass: 'js-form__input-select',
						setAttr: 'data-fullwidth',
						setValue: 'true',
					},
					{
						helperClass: 'js-form__input-select--search',
						setAttr: 'data-search',
						setValue: 'true',
					},
					{
						helperClass: 'js-form__input-select--market',
						setAttr: 'data-cookie',
						setValue: 'cov_market',
					},
				],
			},
		];

		// make a reset button out of it
		const $buttonCancel = $(`.${cancelButtonSelector}`, $ctx);

		// late bind terrfic modules
		terrificControlMap.forEach((control) => {
			const $formControls = $(control.selector, $ctx);
			const $formControlValidationErrorSelector = 'field-validation-error';
			if (!$formControls) {
				return;
			}

			$formControls.each((index, element) => {
				const $this = $(element);
				$this.attr('data-t-name', control.terrificName);

				// add additional attributes before startNode
				control.componentAttr.forEach((attr) => {
					if ($this.hasClass(attr.helperClass)) {
						$this.attr(attr.setAttr, attr.setValue);
					}
				});

				startNode(element);

				if ($this.hasClass('input-validation-error')) {
					$this.prev('label').addClass('state-a-label--has-error');

					const $select2Container = $this.next('.select2-container');
					if ($select2Container.length) {
						const $select2Single = $select2Container.find('.select2-selection--single');
						// Get value from select2 container
						const value =
							$this instanceof HTMLSelectElement && !$this.val()
								? $select2Container.find('.select2-selection__rendered').attr('title')
								: $this.val();

						if (value) {
							$select2Single.removeClass('select2-validation-error');
						} else {
							$select2Single.addClass('select2-validation-error');
						}
					}
				}

				// hide error on focus
				$this.on('focus', () => {
					if ($this.next().hasClass($formControlValidationErrorSelector)) {
						$this.next().hide();
					}

					// Handle select2 components
					if ($this.hasClass('input-validation-error')) {
						const $select2Container = $this.next('.select2-container');
						if ($select2Container.length) {
							const $select2Single = $select2Container.find('.select2-selection--single');

							// Get value from select2 container
							const value =
								$this instanceof HTMLSelectElement && !$this.val()
									? $select2Container.find('.select2-selection__rendered').attr('title')
									: $this.val();

							if (value) {
								$select2Single.removeClass('select2-validation-error');
							} else {
								$select2Single.addClass('select2-validation-error');
							}
						}
					}
				});

				// show error on blur if value did not change
				$this.on('blur', () => {
					$this.next().show();

					// Check if the current field is invalid and has validation error class
					if ($this.hasClass('input-validation-error')) {
						// Handle select2 components
						const $select2Container = $this.next('.select2-container');
						if ($select2Container.length) {
							const $select2Single = $select2Container.find('.select2-selection--single');

							// Get value from select2 container
							const value =
								$this instanceof HTMLSelectElement && !$this.val()
									? $select2Container.find('.select2-selection__rendered').attr('title')
									: $this.val();

							if (!value) {
								$select2Single.addClass('select2-validation-error');
							}
						}
					}
				});
			});
		});

		// check for cancel button placed from sitecore
		if ($buttonCancel.length !== 0) {
			// set type to reset
			$buttonCancel.attr('type', 'reset');
			// cleanup errors on the form & update label state (cause sitecore won't do this for us)
			$buttonCancel.on('click', (ev: Event) => {
				$('input + span, select + span, label + span', $ctx)
					.not('.select2')
					.text('');
				$('.state-a-label--has-error', $ctx)
					.removeClass('state-a-label--has-error')
					.css('max-width', '');
				$(`.${FormControlLabelStateClass.Floated.toString()}`, $ctx).each((index, element) => {
					if (
						!$(element)
							.next()
							.is('select')
					) {
						$(element).removeClass(FormControlLabelStateClass.Floated.toString());
					}
				});
				$(`.${FormControlSiteCoreStateClass}`, $ctx).removeClass(FormControlSiteCoreStateClass);
			});
		}

		// init normal terrific components
		$.each($ctx.find('[data-t-name]'), (i: number, module: Node) => {
			startNode(module);
		});
	}

	inputSelecteOptionChanged(ev: any) {
		const opt: string = ev.currentTarget.value.toLowerCase();

		const $categoryInputContainer: any = this.$ctx.find(`.o-form__grid-col--input-reffered-by`);
		if (opt === optionValues.referredby.toLowerCase()) {
			$('input[data-sc-field-name="yourReferral"]').val('');
			$categoryInputContainer.show();
			setTimeout(() => {
				$categoryInputContainer
					.find('.js-a-input--referredby')
					.focus()
					.select();
			}, 150);
		} else {
			$categoryInputContainer.hide();
			$('input[data-sc-field-name="yourReferral"]').val('-');
		}
	}

	categorySelectedOptionChanged(ev: any) {
		const opt: string = ev.currentTarget.value.toLowerCase();

		if (opt.toLowerCase() === 'products') {
			this.$ctx.find(`.${classes.productsDetailsSection}`).removeClass('o-form-row-products-category--hide');
			this.productValidation = true;
			this.$ctx.find('.js-form__input-category-type').val('');
			this.$ctx.find('.js-form__input-material-type').val('');
			this.$ctx.find('.js-form__input-industry-type').val('');
			this.$ctx.find('.js-form__input-inquiry-type').val('');
		} else {
			this.$ctx.find(`.${classes.productsDetailsSection}`).addClass('o-form-row-products-category--hide');
			this.productValidation = false;
			this.$ctx.find('.js-form__input-category-type').val('Supplier');
			this.$ctx.find('.js-form__input-material-type').val('M2_Adhesives');
			this.$ctx.find('.js-form__input-industry-type').val('Automotive');
			this.$ctx.find('.js-form__input-inquiry-type').val('Technical');
		}
	}

	inputSelecteValidation(ev: any) {
		const $target: any = $(ev.currentTarget);
		const $formControlValidationErrorSelector = 'field-validation-error';

		if ($target.val() !== '') {
			if ($target.nextAll().hasClass($formControlValidationErrorSelector)) {
				$target.nextAll('.' + $formControlValidationErrorSelector).hide();
			}
		} else {
			var dataValRequired = $target.attr('data-val');
			if (typeof dataValRequired !== 'undefined' && dataValRequired !== '' && dataValRequired !== null) {
				$target.nextAll('.' + $formControlValidationErrorSelector).show();
			}
		}
	}

	initMutationObserver($ctx: any) {
		new MutationObserver(() => {
			this._initTerrificModules($ctx);
			this.initAjaxListeners();
		}).observe(this._ctx, {
			childList: true,
			subtree: true,
		});
	}

	initUserVali() {
		const $vali = this.$ctx.find('.js-vali');
		if ($vali.length) {
			$vali.val(`${this.$ctx.find('form:eq(0)').data('sc-fxb')}-jsvali`);
		}
	}

	submitButtonClickForGA() {
		// Script to submit the data to GA
		const submitButtonSelector = 'js-form__button-gtm-event--submit';
		const $buttonSubmit = $(`.${submitButtonSelector}`, this.$ctx);
		if ($buttonSubmit.length !== 0) {
			$buttonSubmit.on('click', (ev: Event) => {
				setTimeout(() => {
					if ($($($(ev.target).parents('form:first')[0]).find('.field-validation-error')).length === 0) {
						const formId = $($(ev.target).parents('form:first')[0]).attr('id');
						const formName = $(
							$($(ev.target).parents('form:first')[0]).find("input[data-sc-field-name='HiddenFormName']")
						).val();

						const trackdata: {
							event: string;
							form_id: string;
							form_name: string;
							form_destination: string;
							form_submit_text: string;
						} = {
							event: 'form_submit',
							form_id: formId,
							form_name: formName.toString(),
							form_destination: '',
							form_submit_text: '',
						};

						Track.gtmTrack(trackdata);
					}
				}, 1000);
			});
		}
	}

	sendFromStartDataToGtm() {
		const formId = this.$ctx.find('form:first').attr('id');
		const formName = this.$ctx.find("input[data-sc-field-name='HiddenFormName']").val();
		const scSendDataToGTMOnPageLoad = this.$ctx.find('input[data-sc-field-name="SendDataToGTMOnPageLoad"]').val();
		const sendDataToGtm = scSendDataToGTMOnPageLoad !== undefined && scSendDataToGTMOnPageLoad === 'Yes';
		if (sendDataToGtm) {
			const trackdata: {
				event: string;
				form_id: string;
				form_name: string;
				form_destination: string;
				form_submit_text: string;
			} = {
				event: 'form_start',
				form_id: formId,
				form_name: formName.toString(),
				form_destination: '',
				form_submit_text: '',
			};

			Track.gtmTrack(trackdata);
		}
	}

	emailValidationChangeEventForWorkdayForm() {
		const emailAddressTextboxSelector = 'js-form__input-email-address';
		const $emailAddressTextbox = $(`.${emailAddressTextboxSelector}`, this.$ctx);

		if ($emailAddressTextbox.length !== 0) {
			$emailAddressTextbox.on('blur touchend', (ev: Event) => {
				const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$/;
				const emailAddress = $(ev.target)
					.val()
					.toString();
				if (emailPattern.test(emailAddress)) {
					const serviceUrl = window.location.origin + '/api/verifyemail?emailAddress=' + emailAddress;

					if (serviceUrl) {
						this.onScAjaxStart();
						$.ajax({
							method: 'get',
							url: serviceUrl,
							success: (jsonData: any) => {
								this.onScAjaxComplete('', 'success');
								var emailAddressExistsErrorMessage = this.$ctx
									.find('input[data-sc-field-name="emailAlreadyExistsErrorMessage"]')
									.val();
								for (const key in jsonData) {
									if (jsonData[key] !== null && jsonData['emailExists'] == true) {
										$(ev.target).addClass('input-validation-error');
										$(ev.target)
											.nextAll('.field-validation-valid')
											.addClass('field-validation-error');
										if (
											emailAddressExistsErrorMessage !== undefined &&
											emailAddressExistsErrorMessage != null
										) {
											$(ev.target)
												.nextAll('.field-validation-valid')
												.text(emailAddressExistsErrorMessage.toString());
										} else {
											$(ev.target)
												.nextAll('.field-validation-valid')
												.text($(ev.target).attr('data-val-required'));
										}

										this.onScAjaxComplete('', 'success');
										return false;
									}
								}
							},
							complete: () => {},
							error: (xhr: any, status: string, error: string) => {
								console.log(
									`lightbox: get partial-view error, endpoint: ${serviceUrl}, ${xhr.status}, ${
										xhr.statusText
									}, ${error}`
								);
								this.onScAjaxComplete(xhr, status);
							},
						});
					}
				}
			});
		}
	}

	prefillFormData() {
		let serviceUrl = this.$ctx.data('api-endpoint');
		if (serviceUrl) {
			serviceUrl =
				serviceUrl.toString().indexOf('?') > -1
					? serviceUrl + '&callForWorkdayApi=false&callForCdpIdApi=false'
					: serviceUrl + '?callForWorkdayApi=false&callForCdpIdApi=false';
			$.ajax({
				method: 'get',
				url: serviceUrl,
				success: (jsonData: any) => {
					for (const key in jsonData) {
						if (jsonData[key] !== null) {
							const $input = this.$ctx.find('[data-sc-field-name="' + key + '"]');
							$input.val(jsonData[key]);
							$input.trigger('change');
						}
					}
				},
			});
		}
	}

	getValueFromObject(myMktoHiddenMetaData: any, materialTagValue: any): string {
		let title: string = '';
		myMktoHiddenMetaData.forEach((element: any) => {
			if (element.tagId === materialTagValue) {
				title = element.tagTitle.toString();
			}
		});
		return title;
	}

	workdayJobsFormData() {
		let workdayapiEndpoint = this.$ctx.data('api-endpoint');
		if (!workdayapiEndpoint) return;
		workdayapiEndpoint =
			workdayapiEndpoint.toString().indexOf('?') > -1
				? workdayapiEndpoint + '&callForWorkdayApi=true&callForCdpIdApi=false'
				: workdayapiEndpoint + '?callForWorkdayApi=true&callForCdpIdApi=false';

		$.ajax({
			method: 'GET',
			url: workdayapiEndpoint,
			success: (jsonData: any) => {
				if (jsonData && jsonData.WorkdayJobsTasks) {
					try {
						const tasksData = JSON.parse(jsonData.WorkdayJobsTasks);

						if (tasksData && tasksData.Report_Entry && Array.isArray(tasksData.Report_Entry)) {
							const jobEntries: any[] = tasksData.Report_Entry;

							const $jobProfileDropdown = this.$ctx.find('[data-sc-field-name="yourPreferredJob"]');
							const $jobProfileDropdownAlt = this.$ctx.find('[data-sc-field-name="yourAlternativeJob"]');
							const $locationDropdown = this.$ctx.find('[data-sc-field-name="yourAlternateLocation"]');

							$jobProfileDropdown.empty(); // Clear existing options
							$jobProfileDropdownAlt.empty(); // Clear existing options
							$locationDropdown.empty(); // Clear existing options

							$jobProfileDropdown.append(new Option('', ''));

							// Populate jobProfiles and jobProfileLocations
							jobEntries.forEach((entry: any) => {
								const jobProfile = entry.Job_Profile;
								const location = entry.Primary_Location;
								const jobRequisitionId = entry.Job_Requisition_ID;

								if ($jobProfileDropdown.find(`option[value="${jobProfile}"]`).length === 0) {
									$jobProfileDropdown.append(new Option(jobProfile, jobProfile));
									$jobProfileDropdownAlt.append(new Option(jobProfile, jobProfile));
								}

								if ($locationDropdown.find(`option[value="${location}"]`).length === 0) {
									$locationDropdown.append(new Option(location, location));
								}

								if (!jobProfileLocations[jobProfile]) {
									jobProfileLocations[jobProfile] = new Set<string>();
								}
								jobProfileLocations[jobProfile].add(location);
							});

							// Handle change event for job profile dropdown (yourPreferredJob)
							$jobProfileDropdown.on('change', () => {
								const selectedProfile = $jobProfileDropdown.val() as string;
								const locations = jobProfileLocations[selectedProfile] || new Set<string>();

								const $preferredLocationDropdown = this.$ctx.find(
									'[data-sc-field-name="yourPreferredLocation"]'
								);
								$preferredLocationDropdown.empty(); // Clear existing options

								$preferredLocationDropdown.append(new Option('', ''));
								locations.forEach((location: string) => {
									$preferredLocationDropdown.append(new Option(location, location));
								});

								// Enable all options first/
								$jobProfileDropdownAlt.find('option').prop('disabled', false);

								// Disable selected profile in yourAlternativeJob dropdown
								if (selectedProfile) {
									$jobProfileDropdownAlt
										.find(`option[value="${selectedProfile}"]`)
										.prop('disabled', true);
								}
							});

							// Disable selected location in yourAlternateLocation dropdown based on yourPreferredLocation
							const $preferredLocationDropdown = this.$ctx.find(
								'[data-sc-field-name="yourPreferredLocation"]'
							);
							$preferredLocationDropdown.on('change', () => {
								const selectedLocation = $preferredLocationDropdown.val() as string;

								// Enable all options first
								$locationDropdown.find('option').prop('disabled', false);

								// Disable selected location in yourAlternateLocation dropdown
								if (selectedLocation) {
									$locationDropdown
										.find(`option[value="${selectedLocation}"]`)
										.prop('disabled', true);
								}
							});
						} else {
							console.error('No valid Report_Entry found in WorkdayJobsTasks.');
						}
					} catch (error) {
						console.error('Error parsing WorkdayJobsTasks:', error);
					}
				} else {
					console.error('No WorkdayJobsTasks data found in response.');
				}
			},
			error: (xhr: any, status: any, error: any) => {
				console.error('Error fetching data:', error);
			},
		});
	}

	getCustomerIdFromUrl(): string {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get('cdpid') || ''; // Return the customerId from the URL, or an empty string if not present
	}

	fetchCdpIdData() {
		let customerId: string = this.getCustomerIdFromUrl();
		if (customerId.indexOf(':') > -1) {
			const customerIdParts = customerId.split(':');
			customerId = customerIdParts[1] as string;
		}
		if (customerId) {
			const cdpApiEndpoint = window.location.origin + '/api/getCdpIdData?customerId=' + customerId;

			$.ajax({
				method: 'GET',
				url: cdpApiEndpoint,
				success: (jsonData: any) => {
					if (jsonData && jsonData.cdpPreferenceData) {
						const cdpData = JSON.parse(jsonData.cdpPreferenceData);
						if (cdpData && cdpData.attributes) {
							const attributes = cdpData.attributes;

							// Prefill simple fields like FirstName, LastName, Company, and Email
							const $cdpFirstName = this.$ctx.find('[data-sc-field-name="FirstName"]');
							const $cdpLastName = this.$ctx.find('[data-sc-field-name="LastName"]');
							const $cdpCompany = this.$ctx.find('[data-sc-field-name="Company"]');
							const $cdpCountry = this.$ctx.find('[data-sc-field-name="Country"]');
							const $unsubscribeText = this.$ctx.find('.a-heading--style6.a-unsubscribe-email');

							if ($cdpFirstName.length > 0 && attributes.firstName) {
								$cdpFirstName.val(attributes.firstName).trigger('change');
							}
							if ($cdpLastName.length > 0 && attributes.lastName) {
								$cdpLastName.val(attributes.lastName).trigger('change');
							}
							if ($cdpCompany.length > 0 && attributes.company && attributes.company.name) {
								$cdpCompany.val(attributes.company.name).trigger('change');
							}
							const fieldsToDisable = [
								'[data-sc-field-name="FirstName"]',
								'[data-sc-field-name="LastName"]',
								'[data-sc-field-name="Email"]',
								'[data-sc-field-name="Company"]',
							];

							fieldsToDisable.forEach((selector) => {
								const $field = this.$ctx.find(selector);
								if ($field.length > 0 && $field.val() !== null && $field.val() !== '') {
									$field.prop('readonly', true); // Disable the field
								}
							});

							if (
								$cdpCountry.length > 0 &&
								attributes.cov_primary_address &&
								attributes.cov_primary_address.cov_country
							) {
								$cdpCountry.val(attributes.cov_primary_address.cov_country).trigger('change');

								const selectElement = $cdpCountry;
								if (
									selectElement.length > 0 &&
									selectElement.val() !== null &&
									selectElement.val() !== ''
								) {
									let selectedValue = selectElement.val();
									$(selectElement)
										.find('option')
										.each(function() {
											if ($(this).val() !== selectedValue) {
												$(this).prop('disabled', true);
											} else {
												$(this).prop('disabled', false);
											}
										});
									setTimeout(() => {
										$(selectElement)
											.next('span.select2-container')
											.addClass('select-preselected');
									}, 500);
								}
							}

							// Fill the hidden field (Email in this case) from API response
							const $hiddenEmailField = this.$ctx.find('[data-sc-field-name="Email"]'); // Target hidden field with the data-sc-field-name="Email"
							if ($hiddenEmailField.length > 0 && attributes.primaryEmail) {
								// Set the value of the hidden email field
								$hiddenEmailField.val(attributes.primaryEmail).trigger('change');
							}

							// Check if the unsubscribe email text element exists and update it with the email
							if ($unsubscribeText.length > 0 && attributes.primaryEmail) {
								const email = attributes.primaryEmail;
								$unsubscribeText.html(function(_, html) {
									return html.replace('{email}', email); // Replace the {email} placeholder
								});
							}

							// Prefill checkboxes based on "cov_interests_ind", "cov_interests_mat", "cov_interests_st" from API response

							// For "cov_interests_ind" (Industry Interest Types)
							if (cdpData.attributes.cov_interests_ind) {
								const industryData = cdpData.attributes.cov_interests_ind;
								const $industryCheckboxes = this.$ctx.find(
									'[data-sc-field-name="IndustryInterestTypes"]'
								);

								$industryCheckboxes.each((index, checkbox) => {
									const checkboxValue = $(checkbox).val(); // Get the value of the checkbox

									// Ensure checkboxValue is a string
									if (
										typeof checkboxValue === 'string' &&
										industryData.hasOwnProperty(checkboxValue)
									) {
										// Check if the value in industryData is true and mark the checkbox as checked
										if (industryData[checkboxValue] === true) {
											$(checkbox).prop('checked', true);
										} else {
											$(checkbox).prop('checked', false);
										}
									}
								});
							}

							// For "cov_interests_mat" (Material Interest Types)
							if (cdpData.attributes.cov_interests_mat) {
								const materialData = cdpData.attributes.cov_interests_mat;
								const $materialCheckboxes = this.$ctx.find(
									'[data-sc-field-name="MaterialInterestTypes"]'
								);

								$materialCheckboxes.each((index, checkbox) => {
									const checkboxValue = $(checkbox).val();
									// Ensure checkboxValue is a string
									if (
										typeof checkboxValue === 'string' &&
										materialData.hasOwnProperty(checkboxValue)
									) {
										// Check if the value in materialData is true and mark the checkbox as checked
										if (materialData[checkboxValue] === true) {
											$(checkbox).prop('checked', true);
										} else {
											$(checkbox).prop('checked', false);
										}
									}
								});
							}

							// For "cov_interests_st" (Strategic Interest Types)
							if (cdpData.attributes.cov_interests_st) {
								const strategicData = cdpData.attributes.cov_interests_st;
								const $strategicCheckboxes = this.$ctx.find(
									'[data-sc-field-name="StrategicInterestTypes"]'
								);

								$strategicCheckboxes.each((index, checkbox) => {
									const checkboxValue = $(checkbox).val();
									// Ensure checkboxValue is a string
									if (
										typeof checkboxValue === 'string' &&
										strategicData.hasOwnProperty(checkboxValue)
									) {
										// Check if the value in strategicData is true and mark the checkbox as checked
										if (strategicData[checkboxValue] === true) {
											$(checkbox).prop('checked', true);
										} else {
											$(checkbox).prop('checked', false);
										}
									}
								});
							}

							// Listen for user changes to checkboxes
							// Define the type of selectedValues explicitly
							const selectedValues: { [key: string]: string[] } = {}; // Object with string keys and array of string values
							this.$ctx.find('input[type="checkbox"]').on('change', function() {
								const checkboxValue = $(this).val();
								const isChecked = $(this).prop('checked');

								// Collect selected values and store them for submission
								if (typeof checkboxValue === 'string') {
									const fieldName = $(this).data('sc-field-name'); // Get the field name
									if (!selectedValues[fieldName]) {
										selectedValues[fieldName] = [];
									}
									if (isChecked) {
										selectedValues[fieldName].push(checkboxValue);
									} else {
										// If unchecked, remove the value
										selectedValues[fieldName] = selectedValues[fieldName].filter(
											(value) => value !== checkboxValue
										);
									}
								}

								console.log(selectedValues); // Log the selected values for testing
							});
						}
					} else {
						console.error('No cdpPreferenceData found in response.');
					}
				},
			});
		}
	}

	initAjaxListeners() {
		const $form = this.$ctx.find('form[data-ajax]');
		if ($form.length > 0) {
			const formHash = this.hash($form.attr('id'));
			(window as any)[`scFromAjaxBegin_${formHash}`] = this.onScAjaxStart.bind(this);
			(window as any)[`scFromAjaxComplete_${formHash}`] = this.onScAjaxComplete.bind(this);
			$form.attr('data-ajax-begin', `scFromAjaxBegin_${formHash}`);
			$form.attr('data-ajax-complete', `scFromAjaxComplete_${formHash}`);
		}
	}

	hash(id: string) {
		/* tslint:disable */
		// very basic hashing function
		for (var i = 0, h = 6; i < id.length; ) h = Math.imul(h ^ id.charCodeAt(i++), 9 ** 9);
		return h ^ (h >>> 9);
		/* tslint:enable */
	}

	onScAjaxStart() {
		this.$ctx.append(`
			<div class="o-form__spinner js-o-form__spinner">
				<div class="a-loading-indicator">
					<div class="a-loading-indicator__one"></div>
					<div class="a-loading-indicator__two"></div>
					<div class="a-loading-indicator__three"></div>
				</div>
			</div>`);
	}

	onScAjaxComplete(xhr: any, status: string) {
		if (status !== 'success') {
			console.info('error', xhr);
			// @todo: Add error handling here
		}
		if (!this.productValidation) {
			this.$ctx.find(`.${classes.productsDetailsSection}`).addClass('o-form-row-products-category--hide');
		}
		var applicationFormHiddenField = this.$ctx
			.find('input[data-sc-field-name="applicationFormSubmitClicked"]')
			.val();
		if (applicationFormHiddenField !== undefined && applicationFormHiddenField == 'true') {
			this.$ctx.find('input[data-sc-field-name="applicationFormSubmitClicked"]').val('');
			const scFormName = this.$ctx.find("input[data-sc-field-name='TypeOfForm']").val();
			if (
				scFormName !== undefined &&
				scFormName.toString().toLowerCase() === optionValues.typeofform.toLowerCase()
			) {
				this.$ctx.find(`.o-form__grid-col--input-reffered-by`).hide();
				this.$ctx.find('input[data-sc-field-name="yourReferral"]').val('-');
				this.workdayJobsFormData();
			}
		}
		this.$ctx.find('.js-o-form__spinner').remove();
		if (stepTwoFormLoaded == true) {
			setTimeout(() => {
				const legalFormSectionRegStromOption = $('.js-form__section-registration-strom');
				const legalFormSectionRegGasOption = $('.js-form__section-registration-gas');
				const spanFileUploadValidationMessage = $('.js-form__file-upload-validation-message');
				const hiddenSectionsFileUpload = $('.js-form__section-registration-file-upload');
				const hiddenSectionsDate = $('.js-form__section-registration-date');
				const hiddenSectionsMeterNo = $('.js-form__section-registration-meter-number');
				spanFileUploadValidationMessage.hide();
				legalFormSectionRegGasOption.hide();
				legalFormSectionRegStromOption.hide();
				hiddenSectionsMeterNo.hide();
				hiddenSectionsFileUpload.hide();
				const radioButtons: any = document.querySelectorAll('.o-form__legal-radio input[type="radio"]');
				const radioButtonsStepTwo: any = document.querySelectorAll(
					'.o-form__legal-steptwo-radio input[type="radio"]'
				);
				const selectBoxStepTwo: any = $('.o-form__legal-steptwo-select');
				if (
					selectBoxStepTwo.val() !== 'Veränderung Netzanschluss' &&
					selectBoxStepTwo.val() !== 'Abmeldung Netzanschluss'
				) {
					hiddenSectionsFileUpload.show();
					hiddenSectionsDate.show();
					var inputValue = $('input[type="radio"]:checked').val();
					if (inputValue == 'Gas') {
						legalFormSectionRegGasOption.show();
					} else if (inputValue == 'Strom') {
						legalFormSectionRegStromOption.show();
					} else {
						legalFormSectionRegGasOption.hide();
						legalFormSectionRegStromOption.hide();
					}
				} else if (selectBoxStepTwo.val() === 'Veränderung Netzanschluss') {
					this.hideStepTwoDateSection();
					this.hideStepTwoGasSection();
					this.hideStepTwoStromSection();
					this.hideStepTwoFileUploadSection();
					this.hideStepTwoMeterNoSection();
					spanFileUploadValidationMessage.hide();
					hiddenSectionsFileUpload.hide();
					hiddenSectionsDate.hide();
				} else {
					$('.js-form__section-registration-date').show();
					$('.js-form__section-registration-meter-number').show();
					this.hideStepTwoGasSection();
					this.hideStepTwoStromSection();
					this.hideStepTwoFileUploadSection();
					spanFileUploadValidationMessage.hide();
				}

				const radioButtonsStepThree: any = document.querySelectorAll(
					'.o-form__legal-stepthree-radio input[type="radio"]'
				);

				radioButtons.forEach((radio: any) => {
					radio.addEventListener('click', (ev: Event) => this.bindRadioButtonClick(ev));
				});

				radioButtonsStepTwo.forEach((radio: any) => {
					radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepTwoClick(ev));
				});

				radioButtonsStepThree.forEach((radio: any) => {
					radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepThreeClick(ev));
				});

				Array.from(selectBoxStepTwo).forEach((selectBox: any) => {
					$(selectBox).on('change', (ev: Event) => this.bindSelectBoxStepTwoChange(ev));
				});

				radioButtonsStepTwo.forEach((radio: any) => {
					if (radio.checked) {
						if (radio.value == 'Gas' && selectBoxStepTwo.val() === 'Veränderung Netzanschluss') {
							legalFormSectionRegGasOption.hide();
						} else if (radio.value == 'Strom' && selectBoxStepTwo.val() === 'Veränderung Netzanschluss') {
							legalFormSectionRegStromOption.hide();
						} else if (radio.value == 'Gas' && selectBoxStepTwo.val() === 'Abmeldung Netzanschluss') {
							legalFormSectionRegGasOption.hide();
						} else if (radio.value == 'Strom' && selectBoxStepTwo.val() === 'Abmeldung Netzanschluss') {
							legalFormSectionRegStromOption.hide();
						} else if (radio.value == 'Gas' && selectBoxStepTwo.val() === 'Anmeldung Netzanschluss') {
							legalFormSectionRegGasOption.show();
						} else {
							legalFormSectionRegStromOption.show();
						}
					}
				});

				const buttonPrevious: any = document.querySelectorAll('.js-form__button--previous');
				buttonPrevious.forEach((button: any) => {
					button.addEventListener('click', (ev: Event) => this.bindStepTwoPreviousButtonClick(ev));
				});

				const buttonNextSecond: any = document.querySelectorAll('.js-form__button-step-two--submit');
				buttonNextSecond.forEach((button: any) => {
					button.addEventListener('click', (ev: Event) => this.bindStepTwoButtonClick(ev));
				});
			}, 1000);
		}
		if (stepThreeFormLoaded == true) {
			const legalFormSectionYesOption = $('.js-form__section-for-yes-option');
			legalFormSectionYesOption.hide();
			const radioButtonsStepThree: any = document.querySelectorAll(
				'.o-form__legal-stepthree-radio input[type="radio"]'
			);
			radioButtonsStepThree.forEach((radio: any) => {
				if (radio.checked) {
					if (radio.value !== 'Ja') {
						legalFormSectionYesOption.hide();
					} else {
						legalFormSectionYesOption.show();
					}
				}
			});
			radioButtonsStepThree.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => this.bindRadioButtonStepThreeClick(ev));
			});
			const buttonPrevious: any = document.querySelectorAll('.js-form__button--previous');
			buttonPrevious.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepThreePreviousButtonClick(ev));
			});
			const buttonNextThree: any = document.querySelectorAll('.js-form__button-step-three--submit');
			buttonNextThree.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepThreeOneButtonClick(ev));
			});
		}
		if (stepFourOneFormLoaded == true) {
			const legalFormSectionYesOption = $('.js-form__section-for-yes-option-next');
			const legalFormSectionNextYesOptionYes = $('.js-form__section-for-next-yes-option-yes');
			const legalFormSectionNo = $('.js-form__section-for-no-option');
			legalFormSectionYesOption.hide();
			legalFormSectionNextYesOptionYes.hide();
			legalFormSectionNo.hide();
			const radioButtonsStepFourOne = document.querySelectorAll(
				'.o-form__legal-stepfour-one-radio input[type="radio"]'
			);
			const radioButtonsStepFourOneArray = Array.from(radioButtonsStepFourOne);
			radioButtonsStepFourOneArray.forEach((radio: any) => {
				if (radio.checked) {
					if (radio.value !== 'Ja') {
						legalFormSectionYesOption.hide();
						legalFormSectionNextYesOptionYes.hide();
						legalFormSectionNo.hide();
					} else {
						legalFormSectionYesOption.show();
					}
				}
			});
			const radioButtonsStepFourArray = Array.from(radioButtonsStepFourOne);
			radioButtonsStepFourArray.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => {
					this.bindRadioButtonStepFourOneClick(ev);
				});
			});
			const buttonPrevious: any = document.querySelectorAll('.js-form__button--previous');
			buttonPrevious.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepFourPreviousButtonClick(ev));
			});

			const buttonNextThree: any = document.querySelectorAll('.js-form__button-step-three--submit');
			buttonNextThree.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepThreeTwoButtonClick(ev));
			});
		}
		if (stepFourTwoFormLoaded == true) {
			const legalFormSectionNextYesOptionYes = $('.js-form__section-for-next-yes-option-yes');
			const legalFormSectionNo = $('.js-form__section-for-no-option');
			legalFormSectionNextYesOptionYes.hide();
			legalFormSectionNo.hide();
			const radioButtonsStepFourTwo = document.querySelectorAll(
				'.o-form__legal-stepfour-two-radio input[type="radio"]'
			);
			const radioButtonsStepFourTwoArray = Array.from(radioButtonsStepFourTwo);
			radioButtonsStepFourTwoArray.forEach((radio: any) => {
				if (radio.checked) {
					if (radio.value !== 'Ja') {
						legalFormSectionNo.show();
					} else {
						legalFormSectionNextYesOptionYes.show();
					}
				}
			});
			const radioButtonsStepFourArray = Array.from(radioButtonsStepFourTwo);
			radioButtonsStepFourArray.forEach((radio: any) => {
				radio.addEventListener('click', (ev: Event) => {
					this.bindRadioButtonStepFourTwoClick(ev);
				});
			});
			const buttonPrevious: any = document.querySelectorAll('.js-form__button--previous');
			buttonPrevious.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepFourPreviousButtonClick(ev));
			});
			const buttonNextFour: any = document.querySelectorAll('.js-form__button-step-four-submit');
			buttonNextFour.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepFourButtonClick(ev));
			});
		}
		if (stepFiveFormLoaded == true) {
			const buttonPrevious: any = document.querySelectorAll('.js-form__button--previous');
			buttonPrevious.forEach((button: any) => {
				button.addEventListener('click', (ev: Event) => this.bindStepFivePreviousButtonClick(ev));
			});
		}
	}
}
